// React import
import { useState, useRef } from 'react';

// Mui imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

// FontAwesomeIcon imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFunction } from '@fortawesome/pro-light-svg-icons';

// Local import
import CurrencyTextField from './CurrencyTextField.js';
import FormulaEditorModal from './FormulaEditorModal.js';
import { formulaToParams, formulaToText } from '../../utils/Formula.js';

function CurrencyFormulaTextField(props) {
    const { value, setValue, focused, setFocused, focusedId, currency, setCurrency, onBlur, onCancelBlur, disabled, width, formula, setFormula, inputRef, sections, organization, withBuyingMargin, multiplierText, showLCLWM } = props;
    const [ formulaDialogOpen, setFormulaDialogOpen ] = useState(false);
    const ref = useRef(null);

    function onClick() {
        if (!!formula && focusedId != focused) {
            setFocused(focusedId);
        }
    }

    if (!!formula && (focused !== focusedId || (focused === undefined && focusedId === undefined))) {
        return (
            <Box sx={{ display: 'flex', padding: '0px 4px 0px 12px', fontStyle: 'italic', color: grey[500], fontSize: '12px', alignItems: 'center', gap: '4px' }}>
                <Box
                    sx={{ flex: 1, cursor: setFormula ? 'pointer' : 'default', padding: '4px 8px', borderRadius: '4px', border: '1px dashed #cbd5e1', '&:hover': setFormula ? { backgroundColor: '#f1f5f9', borderColor: '#94a3b8' } : {} }}
                    onClick={() => { if (setFormula) setFormulaDialogOpen(true); else onClick(); }}
                >
                    {formulaToText({ formula, currency, multiplierText: multiplierText || 'unit', errorValue: 'Formula' })}
                </Box>
                {setFormula && (
                    <Button size='small' sx={{ minWidth: 'auto', padding: '2px 4px', fontSize: '11px', textTransform: 'none' }} onClick={() => { setFormula(null); if (setValue) setValue(0); }}>
                        ✕
                    </Button>
                )}
                {formulaDialogOpen && (
                    <FormulaEditorModal
                        open={formulaDialogOpen}
                        onClose={() => setFormulaDialogOpen(false)}
                        value={formula}
                        onDone={v => { setFormulaDialogOpen(false); setFormula(v); }}
                        sections={sections}
                        currency={currency}
                        organization={organization}
                        showLCLWM={showLCLWM}
                    />
                )}
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
            <CurrencyTextField
                value={formula ? 'Formula' : value}
                setValue={formula ? () => {} : setValue}
                focused={focused}
                setFocused={setFocused}
                focusedId={focusedId}
                currency={currency}
                setCurrency={setCurrency}
                onBlur={onBlur}
                onCancelBlur={onCancelBlur}
                disabled={disabled}
                width={width}
                inputRef={inputRef}
                organization={organization}
                hasNextButton={focused === focusedId}
            />
            {(focused === focusedId) && (
                <Button
                    disabled={disabled}
                    variant='text'
                    color='primary'
                    size='small'
                    className='function-button'
                    sx={{ 
                        minWidth: 'auto',
                        padding: '0px 12px',
                        fontSize: '13px',
                        fontWeight: 500,
                        textTransform: 'none',
                        color: '#2563EB',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #2563EB',
                        borderLeft: 'none',
                        borderRadius: '0px 6px 6px 0px',
                        alignSelf: 'stretch',
                        boxShadow: 'none',
                        marginTop: 0,
                        marginBottom: 0,
                        height: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        '&:hover': {
                            backgroundColor: '#F9FAFB',
                            boxShadow: 'none',
                            borderColor: '#2563EB',
                        },
                        '&.Mui-disabled': {
                            backgroundColor: '#FFFFFF',
                            borderColor: '#E5E7EB',
                            color: '#667085',
                        },
                    }}
                    onClick={() => {
                        onCancelBlur();
                        setFormulaDialogOpen(true)
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault(); // Prevent blur of input
                    }}
                >
                    <FontAwesomeIcon icon={faFunction} style={{ fontSize: '14px' }} />
                </Button>
            )}
            <FormulaEditorModal
                open={formulaDialogOpen}
                onClose={() => setFormulaDialogOpen(false)}
                value={formula || ''}
                onDone={v => { setFormulaDialogOpen(false); setFormula(v);}}
                sections={sections}
                withBuyingMargin={withBuyingMargin}
                showLCLWM={showLCLWM}
            />
        </Box>
    )
}

export default CurrencyFormulaTextField;
